<template>
  <nav class="navbar" :class="{ 'scrolled': isScrolled }">
    <div class="container">
      <div class="nav-content">
        <div class="nav-brand">
          <img src="../assets/vigas-logo.png" alt="VI-GAS" class="logo vigas-logo">
          <img src="../assets/viessmann-logo.png" alt="Viessmann" class="logo viessmann-logo">
        </div>
        
        <ul class="nav-menu" :class="{ 'active': mobileMenuOpen }">
          <li><router-link :to="{ name: 'About' }" @click="closeMenu">O nas</router-link></li>
          <li><router-link :to="{ name: 'Services' }" @click="closeMenu">Oferta</router-link></li>
          <li><router-link :to="{ name: 'SmartHome' }" @click="closeMenu">Smart Dom</router-link></li>
          <li><router-link :to="{ name: 'Location' }" @click="closeMenu">Lokalizacja</router-link></li>
          <li><router-link :to="{ name: 'Reviews' }" @click="closeMenu">Opinie</router-link></li>
          <li><router-link :to="{ name: 'Contact' }" @click="closeMenu">Kontakt</router-link></li>
          <li>
            <a href="tel:+48570422020" class="emergency-btn">
              📞 +48 570 422 020
            </a>
          </li>
        </ul>
        
        <button class="hamburger" @click="toggleMenu" :class="{ 'active': mobileMenuOpen }">
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </div>
  </nav>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue'

export default {
  name: 'NavigationBar',
  setup() {
    const isScrolled = ref(false)
    const mobileMenuOpen = ref(false)
    
    const handleScroll = () => {
      isScrolled.value = window.scrollY > 50
    }
    
    const toggleMenu = () => {
      mobileMenuOpen.value = !mobileMenuOpen.value
    }
    
    const closeMenu = () => {
      mobileMenuOpen.value = false
    }
    
    onMounted(() => {
      window.addEventListener('scroll', handleScroll)
    })
    
    onUnmounted(() => {
      window.removeEventListener('scroll', handleScroll)
    })
    
    return {
      isScrolled,
      mobileMenuOpen,
      toggleMenu,
      closeMenu
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
  padding: 15px 0;
  
  &.scrolled {
    padding: 10px 0;
    box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
  }
}

.nav-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.nav-brand {
  display: flex;
  align-items: center;
  gap: 20px;
  
  .logo {
    height: 80px;
    width: auto;
    transition: all 0.3s ease;
    
    &.vigas-logo {
      // VI-GAS logo specific styles
      filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
    }
    
    &.viessmann-logo {
      // Viessmann logo specific styles
      height: 35px; // Slightly smaller for balance
      filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
    }
    
    &:hover {
      transform: scale(1.05);
    }
  }
}

.nav-menu {
  display: flex;
  list-style: none;
  gap: 30px;
  align-items: center;
  
  li {
    a,
    router-link {
      text-decoration: none;
      color: #333;
      font-weight: 500;
      transition: color 0.3s ease;
      display: inline-block;
      
      &:hover {
        color: #FF6B35;
      }
    }
  }
  
  .emergency-btn {
    background: #FF6B35;
    color: white !important;
    padding: 8px 15px;
    border-radius: 25px;
    font-size: 0.9rem;
    
    &:hover {
      background: #e55a2b;
    }
  }
}

.hamburger {
  display: none;
  flex-direction: column;
  cursor: pointer;
  
  span {
    width: 25px;
    height: 3px;
    background: #333;
    margin: 3px 0;
    transition: 0.3s;
  }
  
  &.active {
    span:nth-child(1) {
      transform: rotate(-45deg) translate(-5px, 6px);
    }
    
    span:nth-child(2) {
      opacity: 0;
    }
    
    span:nth-child(3) {
      transform: rotate(45deg) translate(-5px, -6px);
    }
  }
}

@media (max-width: 768px) {
  .hamburger {
    display: flex;
  }
  
  .nav-brand {
    gap: 15px; // Reduce gap on mobile
    
    .logo {
      height: 35px; // Smaller on mobile
      
      &.viessmann-logo {
        height: 30px;
      }
    }
  }
  
  .nav-menu {
    position: fixed;
    left: -100%;
    top: 70px;
    flex-direction: column;
    background: white;
    width: 100%;
    text-align: center;
    transition: 0.3s;
    box-shadow: 0 10px 27px rgba(0, 0, 0, 0.05);
    padding: 20px 0;
    
    &.active {
      left: 0;
    }
    
    li {
      margin: 10px 0;
    }
  }
}

// Fallback styles if images fail to load
.logo {
  &:not([src]) {
    background: linear-gradient(135deg, #FF6B35, #FFD93D);
    color: white;
    padding: 8px 16px;
    border-radius: 8px;
    font-weight: bold;
    
    &.viessmann-logo {
      background: linear-gradient(135deg, #004F9F, #0066CC);
    }
  }
}
</style>